<div class="b2a-introtext">
  <div class="b2a-introtext__title">
    <ng-content select="h1"></ng-content>
  </div>
  <div class="b2a-introtext__description">
    <ng-content select="p"></ng-content>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/introtext/introtext.component.html